import { DaciExtComponent } from '../cixtec/daciExt/daciExt.component';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { PlycaDataService } from '../../services/plyca.service';
import { Component, OnInit, OnDestroy, ElementRef, AfterContentInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { HelpService } from '../components/common/help/help.service';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { DialogService, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { Configuration } from '../conf/app.constants';
import { UIService } from '../ui.service';
import { HeaderActionsService } from '../components/common/sub-header/header-actions.service';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';
import { ActionParameterDefinitionDTO, ProjectEntityDTO } from '../api/plyca-dtos-v2';
import { SearchSettingDTOModal, searchGenericComponent } from '../components/search/searchGeneric.component';
import { AppConfiguration } from '../conf/app.configuration';
import { ConfirmationService } from 'primeng-lts/api';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'projectEntityUserAuthorization',
  templateUrl: 'projectEntityUserAuthorization.template.html',
  providers: [DialogService]
})

export class ProjectEntityUserAuthorizationComponent extends BaseComponent implements OnInit, OnDestroy, AfterContentInit {

  public loaded: boolean;
  public projectEntityIdentifier: string;
  public projectEntity: ProjectEntityDTO;
  public projectEntityUserAuthorizations: [];
  public authorizationType: string;
  adaptationCixtecEnabled = false;

  ngOnDestroy() {
    this.uiService = null;
    this.dialogConfig = null;
    this.dialogService = null;
    super.ngOnDestroy();
  }

  constructor(
    protected appConfig: AppConfiguration,
    private plycaErrorHandler: PlycaErrorHandler,
    private headerActionsService: HeaderActionsService,
    private elem: ElementRef,
    private route: ActivatedRoute,
    public helpService: HelpService,
    public uiService: UIService,
    public dialogConfig: DynamicDialogConfig,
    public configuration: Configuration,
    private plycaService: PlycaDataService,
    private waitService: WaitLoadingService,
    private confirmationService: ConfirmationService,
    private translationService: TranslateService,
    public dialogService: DialogService
  ) {
    super();

    this.subscribe(route.params, params => {
      this.projectEntityIdentifier = params['id'];
      this.authorizationType = params['authorizationType'];
      this.subscribe(
        this.plycaService.get<ProjectEntityDTO>(this.configuration.PROJECTENTITY_SERVICE_URL, params['id']),
        projectEntityResult => {
          this.projectEntity = projectEntityResult;
          this.headerActionsService.setProject(this.elem, this.projectEntity, true);
        });
    });

    // Accesos a adaptaciones de CIXTEC
    this.adaptationCixtecEnabled = appConfig.getValue('cliente') === 'CIXTEC';
  }
  ngAfterContentInit(): void {
    this.initForm();
    this.loadFormData();
  }

  ngOnInit() {
  }

  private initForm() {
    this.headerActionsService.clearActions();

    // Título del formulario
    this.headerActionsService.setTaskDescription(
      this.elem,
      'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.Title',
      'fas fa-user-shield',
      true);

    // Acción: Añadir autorización
    this.subscribe(this.headerActionsService.addAction(
      'ProjectEntityUserAuthorization.ProjectEntityUserAuthorizationForm.Actions.InsertProjectEntityUserAuthorization',
      'fas fa-check',
      'btn-primary',
      !this.adaptationCixtecEnabled
    ), () => {
      this.insertProjectEntityUserAuthorization();
    });


    // Acción: Recargar datos del formulario
    this.subscribe(this.headerActionsService.addAction(
      'General.reload',
      'fas fa-sync-alt',
      'btn-secondary',
      true
    ), success => {
      this.loadFormData();
    });
    this.headerActionsService.addDivider();

    // Acción: Volver
    this.subscribe(this.headerActionsService.addAction(
      'General.back',
      'fas fa-chevron-left',
      'btn-outline-secondary',
      true
    ), success => {
      this.uiService.routeBack();
    });
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  private loadFormData() {
    console.log('loadFormData');

    let queryFilter = {
      'projectEntityIdentifier': this.projectEntityIdentifier,
      'excludeDisabled': 'true'
    };
    if (this.authorizationType) {
      queryFilter['authorizationType'] = this.authorizationType;
    }
    console.log('queryFilter', this.projectEntityUserAuthorizations);

    this.waitService.startWaiting();
    this.subscribe(this.plycaService
      .query(this.configuration.PROJECT_ENTITY_USER_AUTHORIZATIONS_URL, queryFilter)
      .pipe(finalize(() => {
        this.waitService.cancelWaiting();
      })),
      (value: any) => {
        if (value && value.content) {
          this.projectEntityUserAuthorizations = value.content;
        } else {
          this.projectEntityUserAuthorizations = [];
        }
        console.log('projectEntityUserAuthorizations', this.projectEntityUserAuthorizations);
        this.waitService.cancelWaiting();
        this.loaded = true;
      });
  }

  public insertProjectEntityUserAuthorization() {
    console.log('insertProjectEntityUserAuthorization');
    this.waitService.startWaiting();

    let selectedUser: any;
    let projectEntityUserAuthorization: any;

    this.subscribe(
      // Seleccionar usuario
      this.openUserSelector(),
      openUserSelectorResult => {
        selectedUser = openUserSelectorResult;
        console.log('selectedUser' + selectedUser);
        if (selectedUser) {
          this.subscribe(
            // Obtener el projectEntityUserAuthorization inicial mediante un newObject
            this.plycaService.get<any>(this.configuration.PROJECT_ENTITY_USER_AUTHORIZATIONS_URL, 'new'),
            newProjectEntityUserAuthorizationResult => {
              projectEntityUserAuthorization = newProjectEntityUserAuthorizationResult;
              console.log('projectEntityUserAuthorization after newObject' + projectEntityUserAuthorization);
              // Completar projectEntityUserAuthorization con el resto de datos
              projectEntityUserAuthorization['projectEntity'] = {
                'identifier': this.projectEntityIdentifier
              };
              projectEntityUserAuthorization['user'] = {
                'identifier': selectedUser.identifier
              }
              if (this.authorizationType) {
                projectEntityUserAuthorization['authorizationType'] = this.authorizationType;
              }
              console.log('projectEntityUserAuthorization before insert' + projectEntityUserAuthorization);
              this.subscribe(
                // Insert de projectEntityUserAuthorization
                this.plycaService.insert<any>(this.configuration.PROJECT_ENTITY_USER_AUTHORIZATIONS_URL, projectEntityUserAuthorization),
                insertProjectEntityUserAuthorizationResult => {
                  projectEntityUserAuthorization = insertProjectEntityUserAuthorizationResult;
                  console.log('projectEntityUserAuthorization after insert' + projectEntityUserAuthorization);
                  this.loadFormData();
                  this.waitService.cancelWaiting();
                  // Fin del caso de uso normal: se ha insertado la nueva autorización, todo ok
                },
                error => {
                  // Error en insert de projectEntityUserAuthorization
                  console.error(error);
                  this.waitService.cancelWaiting();
                  this.plycaErrorHandler.showServerError(error);
                }
              );
            },
            error => {
              // Error en newObject de projectEntityUserAuthorization
              console.error(error);
              this.waitService.cancelWaiting();
              this.plycaErrorHandler.showServerError(error);
            }
          );
        } else {
          // No se seleccionó usuario
          console.error('No se seleccionó usuario');
          this.waitService.cancelWaiting();
        }
      },
      error => {
        // Error al seleccionar usuario
        console.error(error);
        this.waitService.cancelWaiting();
        this.plycaErrorHandler.showServerError(error);
      }
    );
  }

  public deleteProjectEntityUserAuthorization(projectEntityUserAuthorization: any) {

    this.confirmationService.confirm({
      message: this.translationService.instant('Forms.table.deleteRow'),
      acceptLabel: this.translationService.instant('General.yes'),
      rejectLabel: this.translationService.instant('General.no'),
      accept: () => {
        console.log('projectEntityUserAuthorization: ', projectEntityUserAuthorization);
        this.waitService.startWaiting();
        projectEntityUserAuthorization['disabled'] = true; // ¿Clonar?
        this.subscribe(
          this.plycaService.update<any>(this.configuration.PROJECT_ENTITY_USER_AUTHORIZATIONS_URL, projectEntityUserAuthorization),
          response => {
            console.log(response);
            this.loadFormData();
          },
          error => {
            this.waitService.cancelWaiting();
            this.plycaErrorHandler.showServerError(error);
          }
        );
      }
    });


  }

  private openUserSelector() {
    let parametersURL: ActionParameterDefinitionDTO[] = [];
    let param1 = new ActionParameterDefinitionDTO();
    param1.identifier = 'INVITADOS';
    param1.value = 'N';
    parametersURL.push(param1);
    let contextSearch = new SearchSettingDTOModal('com.nexusit.framework.buscador.interfaz.BuscadorUsuarios', true, parametersURL);
    let config: DynamicDialogConfig = {
      header: '',
      width: '70%',
      style: { 'max-height': '80%' }
    };
    config['context'] = contextSearch;
    let ref = this.dialogService.open(searchGenericComponent, config);
    return ref.onClose;
  }
}
